// 注意: 出码引擎注入的临时变量默认都以 "__$$" 开头，禁止在搭建的代码中直接访问。
// 例外：react 框架的导出名和各种组件名除外。
import React from "react";
import ChipEdit from 'ChipEdit';
import chipDataTransform from 'chipDataTransform';


import { LayoutComponent } from "@ifeng-fe/lowcode_basic/src/components/layout/LayoutComponent/index.tsx";

import { ImageLink } from "@ifeng-fe/lowcode_basic/src/components/popular/ImageLink/index.tsx";

import { Nav_1 } from "@ifeng-fe/lowcode_basic/src/components/nav/Nav_1/index.tsx";

import { Container } from "@ifeng-fe/lowcode_basic/src/components/layout/Container/index.tsx";

import { Row } from "@ifeng-fe/lowcode_basic/src/components/layout/Row/index.tsx";

import { Col } from "@ifeng-fe/lowcode_basic/src/components/layout/Col/index.tsx";

import { Title } from "@ifeng-fe/lowcode_basic/src/components/popular/Title/index.tsx";

import { NewsList_1 } from "@ifeng-fe/lowcode_basic/src/components/NewsList/NewsList_1/index.tsx";

import { Swiper_1 } from "@ifeng-fe/lowcode_basic/src/components/Swiper/Swiper_1/index.tsx";

import { VideoList_1 } from "@ifeng-fe/lowcode_basic/src/components/video/VideoList_1/index.tsx";

import { NewsList_12 } from "@ifeng-fe/lowcode_basic/src/components/NewsList/NewsList_12/index.tsx";

import { Swiper_5 } from "@ifeng-fe/lowcode_basic/src/index.tsx";

import { Footer } from "@ifeng-fe/lowcode_basic/src/components/popular/Footer/index.tsx";

import utils from "../../utils";

import "./index.css";

class Layout$$Page extends React.Component {
  _context = this;

  constructor(props, context) {
    super(props);

    this.utils = utils;

    this.state = {};
  }

  $ = () => null;

  $$ = () => [];

  componentDidMount() {}

  render() {
    const __$$context = this._context || this;
    const { state } = __$$context;
    return (
      <div
        style={{ overflowX: "hidden" }}
        hoverStyle=""
        nodeId="node_dockcviv8fo1"
      >
        <LayoutComponent
          isCenter={true}
          nodeId="node_ocl8lkjm3v1i"
          hoverStyle=""
        >
          <ImageLink
            image="https://x0.ifengimg.com/ucms/2024_51/688775E494A298BBC7B16FE8DBA8CE29B5FF2B04_size1995_w5120_h1000.jpg"
            url=""
            isBlock={true}
            width={300}
            height={350}
            objectFit="cover"
            style={{
              display: "block",
              backgroundPositionX: "center",
              backgroundPositionY: "center",
              backgroundSize: "cover",
            }}
            hoverStyle=""
            nodeId="node_ocl8mrdjw62"
          />
          <Nav_1
            navChip={{
              $data: true,
              id: "260963",
              type: "struct",
              title: "导航内容",
              default: { type: "struct", id: "260297" },
              uuid: "2a6d2ee1",
              force: 1734544998743,
            }}
            mainWidth={1000}
            height={80}
            backgroundColor="#542705"
            isHasLeftImage={true}
            isSubTitleUnderline={true}
            subTitleHoverColor="#ffffff"
            subTitleStyle={{
              color: "#ffffff",
              fontWeight: 400,
              fontSize: "16px",
              textAlign: "justify",
            }}
            titleStyle={{
              color: "#ece8e8",
              fontWeight: 400,
              lineHeight: "24px",
              borderTopLeftRadius: "8px",
              borderTopRightRadius: "8px",
              borderBottomLeftRadius: "8px",
              borderBottomRightRadius: "8px",
              textAlign: "center",
              overflowX: "auto",
              width: "60px",
              height: "60px",
              backgroundRepeat: "no-repeat",
              backgroundPositionX: "center",
              backgroundPositionY: "top",
              paddingTop: "5px",
              fontSize: "19px",
              backgroundColor: "#8b6028",
            }}
            leftImageUrl="https://x0.ifengimg.com/ucms/2022_42/F97C21F25CC12931F992999D5ABA015D2C64A8AF_size66_w1754_h417.png"
            leftImageStyle={{ marginRight: "80px" }}
            isSticky={false}
            style={{ paddingRight: "20px", paddingLeft: "20px" }}
            hoverStyle=""
            leftImageWidth={120}
            nodeId="node_ocl8mrdjw63"
          />
        </LayoutComponent>
        <Container
          width={1000}
          isCenter={true}
          hoverStyle=""
          nodeId="node_ocl8lkjm3v1n"
        >
          <LayoutComponent
            isCenter={true}
            nodeId="node_ocl8lkjm3v1o"
            hoverStyle=""
            style={{ width: "1000px" }}
          >
            <Row
              isCenter={true}
              justifyContent="flex-start"
              alignItems="stretch"
              hoverStyle=""
              style={{ width: "1000px" }}
              nodeId="node_ocl8mrdjw64"
              width={1000}
            >
              <Col
                width={{ size: 670, type: "px" }}
                style={{ marginTop: "40px", marginBottom: "20px" }}
                hoverStyle=""
                nodeId="node_ocl8u2cvve1g"
              >
                <Title
                  text=""
                  height={50}
                  image="https://x0.ifengimg.com/ucms/2024_51/1B1803E08A0D8B3118519F7FFD9BDF7BCF6F9028_size3_w780_h50.jpg"
                  textAlign="flex-start"
                  textStyle={{
                    fontWeight: 700,
                    fontSize: "26px",
                    marginRight: "20px",
                  }}
                  isHasAddonAfter={false}
                  addonAfterText="更多"
                  addonAfterTextStyle={{
                    fontSize: "14px",
                    color: "#ffffff",
                    textDecoration: "underline",
                  }}
                  style={{
                    marginRight: "20px",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                    height: "50px",
                    width: "670px",
                  }}
                  hoverStyle=""
                  isTextHasIcon={false}
                  nodeId="node_ocl8u2cvve1w"
                />
                <NewsList_1
                  newsChip={{
                    $data: true,
                    id: "288724",
                    type: "recommend",
                    title: "新闻内容",
                    default: { type: "recommend", id: "285838" },
                    uuid: "31fd8af4",
                    force: 1734543611600,
                  }}
                  hoverColor="#8b6028"
                  titleStyle={{
                    color: "#2b2b2b",
                    fontSize: "26px",
                    fontWeight: 700,
                    lineHeight: "26px",
                    paddingBottom: "15px",
                  }}
                  subTitleGroupSize={2}
                  subTitleStyle={{
                    fontSize: "14px",
                    lineHeight: "26px",
                    fontWeight: 400,
                  }}
                  isHasThumbnail={false}
                  thumbnailWidth={140}
                  thumbnailHeight={100}
                  thumbnailStyle={{ marginRight: "20px" }}
                  hoverStyle=""
                  style={{ paddingRight: "20px", marginTop: "5px" }}
                  itemStyle={{
                    paddingBottom: "24px",
                    marginTop: "24px",
                    borderStyle: "solid",
                    borderWidth: "1px",
                    borderColor: "#dadada",
                  }}
                  nodeId="node_ocl96p0d0t3"
                />
                <NewsList_1
                  newsChip={{
                    $data: true,
                    id: "288725",
                    type: "recommend",
                    title: "新闻内容",
                    default: { type: "recommend", id: "285838" },
                    uuid: "b2aea119",
                    force: 1734544719163,
                  }}
                  hoverColor="#8b6028"
                  titleStyle={{
                    color: "#2b2b2b",
                    fontSize: "26px",
                    lineHeight: "26px",
                    fontWeight: 400,
                    marginBottom: "15px",
                  }}
                  subTitleGroupSize={2}
                  subTitleStyle={{
                    fontSize: "14px",
                    lineHeight: "26px",
                    fontWeight: 400,
                  }}
                  isHasThumbnail={false}
                  thumbnailWidth={140}
                  thumbnailHeight={100}
                  thumbnailStyle={{ marginRight: "20px" }}
                  style={{ paddingRight: "20px", paddingBottom: "20px" }}
                  hoverStyle=""
                  itemStyle={{
                    borderBottomStyleType: "solid",
                    borderBottomStyleColor: "#ebebeb",
                    marginTop: "24px",
                    borderStyle: "none",
                  }}
                  nodeId="node_ocl8u2cvve1o"
                />
                <Title
                  text=""
                  height={50}
                  image="https://x0.ifengimg.com/ucms/2024_51/60F6532EFA78A464B4C89E2197EBE5974788CC6A_size4_w780_h50.jpg"
                  textAlign="flex-start"
                  textStyle={{
                    paddingLeft: "24px",
                    color: "#c33430",
                    fontWeight: 700,
                    fontSize: "20px",
                  }}
                  isHasAddonAfter={false}
                  addonAfterText="更多"
                  addonAfterTextStyle={{
                    fontSize: "14px",
                    color: "#ffffff",
                    textDecoration: "underline",
                  }}
                  style={{
                    backgroundColor: "#ffffff",
                    marginRight: "20px",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                  }}
                  hoverStyle=""
                  nodeId="node_ocl8u8dees9g"
                />
                <NewsList_1
                  newsChip={{
                    $data: true,
                    id: "288726",
                    type: "recommend",
                    title: "新闻内容",
                    default: { type: "recommend", id: "285838" },
                    uuid: "5840d8cf",
                    force: 1734543498561,
                  }}
                  hoverColor="#8b6028"
                  titleStyle={{
                    color: "#2b2b2b",
                    fontSize: "14px",
                    lineHeight: "26px",
                  }}
                  subTitleGroupSize={2}
                  subTitleStyle={{ fontSize: "14px", lineHeight: "26px" }}
                  isHasThumbnail={false}
                  thumbnailWidth={140}
                  thumbnailHeight={100}
                  thumbnailStyle={{ marginRight: "20px" }}
                  style={{ paddingRight: "20px", marginTop: "5px" }}
                  hoverStyle=""
                  itemStyle={{
                    paddingBottom: "24px",
                    marginTop: "24px",
                    borderBottomWidth: "1px",
                    borderBottomStyle: "solid",
                    borderBottomColor: "#ebebeb",
                  }}
                  nodeId="node_ocl8u8dees9a"
                />
              </Col>
              <Col
                width={{ size: 300, type: "px" }}
                style={{
                  marginTop: "40px",
                  marginLeft: "30px",
                  marginBottom: "50px",
                }}
                hoverStyle=""
                nodeId="node_ocl8u2cvve1j"
              >
                <Title
                  text=""
                  height={50}
                  image="https://x0.ifengimg.com/ucms/2024_51/D0784D960022546F61C332366C1A8803D77817A0_size4_w380_h50.jpg"
                  textAlign="flex-start"
                  textStyle={{
                    paddingLeft: "24px",
                    color: "#ffffff",
                    fontWeight: 700,
                    fontSize: "20px",
                  }}
                  isHasAddonAfter={false}
                  addonAfterText="更多"
                  addonAfterTextStyle={{
                    fontSize: "14px",
                    color: "#ffffff",
                    textDecoration: "underline",
                  }}
                  style={{ height: "50px" }}
                  hoverStyle=""
                  nodeId="node_ocl8u2cvve23"
                />
                <Swiper_1
                  swiperChip={{
                    $data: true,
                    id: "288727",
                    type: "recommend",
                    title: "轮播图内容",
                    default: { type: "recommend", id: "285915" },
                    uuid: "e19cba17",
                    force: 1734545899628,
                  }}
                  height={169}
                  loop={false}
                  isHasNav={false}
                  leftNavImage="https://x0.ifengimg.com/ucms/2022_21/27198D15B1E76B0BF8EA2BA44F9A91596603AE9E_size0_w22_h40.png"
                  rightNavImage="https://x0.ifengimg.com/ucms/2022_21/EC3D567431E541D7FC17AABB0F45084B6D227640_size0_w22_h40.png"
                  navWidth={15}
                  navHeight={20}
                  navY={85}
                  navX={10}
                  isAutoPlay={true}
                  autoSpeed={3000}
                  skin={1}
                  isHasTitle={true}
                  titleHeight={36}
                  titleStyle={{
                    background: "linear-gradient(180deg,transparent,#000)",
                    color: "#fff",
                    fontSize: "14px",
                    paddingLeft: "15px",
                    paddingRight: "15px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                  isHasPagination={false}
                  paginationPosition="titleBottom"
                  paginationNormalStyle={{
                    backgroundColor: "rgba(255, 255, 255, 0.5)",
                    borderTopLeftRadius: "50px",
                    borderTopRightRadius: "50px",
                    borderBottomLeftRadius: "50px",
                    borderBottomRightRadius: "50px",
                    width: "4px",
                    height: "4px",
                    marginLeft: "4px",
                    marginRight: "4px",
                  }}
                  paginationActiveStyle={{
                    borderTopLeftRadius: "2px",
                    borderTopRightRadius: "2px",
                    borderBottomLeftRadius: "2px",
                    borderBottomRightRadius: "2px",
                    width: "12px",
                  }}
                  paginationTotalStyle={{ marginBottom: "10px" }}
                  style={{ width: "300px", height: "169px", marginTop: "5px" }}
                  hoverStyle=""
                  nodeId="node_ocl8uc1v7t4"
                />
                <Title
                  text=""
                  height={50}
                  image="https://x0.ifengimg.com/ucms/2024_51/CB3875A067916ACBA7F5808AF5EC1C02406B2379_size4_w380_h50.jpg"
                  textAlign="flex-start"
                  textStyle={{
                    paddingLeft: "24px",
                    color: "#ffffff",
                    fontWeight: 700,
                    fontSize: "20px",
                  }}
                  isHasAddonAfter={false}
                  addonAfterText="更多"
                  addonAfterTextStyle={{
                    fontSize: "14px",
                    color: "#ffffff",
                    textDecoration: "underline",
                  }}
                  style={{ marginTop: "20px", height: "50px" }}
                  hoverStyle=""
                  nodeId="node_ocl8u2cvve24"
                />
                <VideoList_1
                  videoChip={{
                    $data: true,
                    id: "288728",
                    type: "recommend",
                    title: "视频列表",
                    format: { filter: ["title", "posterUrl", "videoPlayUrl"] },
                    default: { type: "recommend", id: "285924" },
                    uuid: "36ce4986",
                    force: 1734544348382,
                  }}
                  width={300}
                  height={169}
                  autoPlay={false}
                  controls={false}
                  hoverColor="#8b6028"
                  skin={0}
                  continuePlay={false}
                  style={{ width: "300px", height: "169px", marginTop: "5px" }}
                  listHeight={48}
                  listIcon=""
                  listIconWidth={14}
                  listIconHeight={9}
                  listStyle={{
                    paddingLeft: "0px",
                    paddingRight: "10px",
                    height: "36px",
                    fontSize: "14px",
                    color: "#2b2b2b",
                  }}
                  hoverStyle=""
                  nodeId="node_ocl8u2cvve1n"
                />
              </Col>
            </Row>
          </LayoutComponent>
          <LayoutComponent
            isCenter={true}
            nodeId="node_ocl8u8dees77"
            hoverStyle=""
            style={{ paddingBottom: "20px" }}
            width={1000}
          >
            <Title
              text=""
              height={70}
              image="https://x0.ifengimg.com/ucms/2024_51/9A567AF6A1CF3DCB110EB994798696742B95D8EA_size147_w2000_h140.jpg"
              textAlign="flex-start"
              textStyle={{ paddingLeft: "24px", fontWeight: 700 }}
              isHasAddonAfter={false}
              addonAfterText="更多"
              addonAfterTextStyle={{
                fontSize: "14px",
                color: "#ffffff",
                textDecoration: "underline",
              }}
              style={{ marginBottom: "20px", width: "1000px" }}
              isTextHasIcon={false}
              hoverStyle=""
              nodeId="node_ocl8u2cvve25"
            />
            <NewsList_12
              newsChip={{
                $data: true,
                id: "288729",
                type: "recommend",
                title: "新闻内容",
                default: { type: "recommend", id: "285873" },
                uuid: "0cafdc73",
                force: 1734457284920,
              }}
              colNum={3}
              thumbnailWidth={320}
              thumbnailHeight={180}
              showThumbnailHoverScale={true}
              isHasTitle={true}
              titleRows={2}
              titleHoverColor="#8b6028"
              titleStyle={{
                color: "#2b2b2b",
                fontSize: "18px",
                lineHeight: "24px",
                fontWeight: 700,
                paddingLeft: "0px",
                paddingRight: "0px",
                textAlign: "justify",
                borderBottomWidth: "1px",
                borderBottomColor: "#e6e5e6",
                borderBottomStyle: "solid",
                marginLeft: "20px",
                marginRight: "20px",
                marginBottom: "10px",
                paddingTop: "15px",
                paddingBottom: "15px",
              }}
              showSummary={true}
              summaryRows={3}
              summaryStyle={{
                color: "#666666",
                fontSize: "14px",
                lineHeight: "26px",
                paddingLeft: "20px",
                paddingRight: "20px",
                textAlign: "justify",
                paddingTop: "10px",
                paddingBottom: "15px",
              }}
              moreText="[详细]"
              moreStyle={{ color: "#8b6028" }}
              itemStyle={{
                borderColor: "#ebebeb",
                borderWidth: "1px",
                borderStyle: "solid",
              }}
              formatImageType={2}
              style={{ borderBottomStyle: "none", width: "1000px" }}
              hoverStyle=""
              titleHeight={50}
              nodeId="node_ocl8u8xf684"
            />
          </LayoutComponent>
          <Container isCenter={true} nodeId="node_oclnsklpmo1">
            <LayoutComponent isCenter={true} nodeId="node_oclnsxs67u1">
              <Title
                text=""
                height={70}
                image="https://x0.ifengimg.com/ucms/2024_51/035A967E2628A2F149DAD188C93FB38A95008A34_size146_w2000_h140.jpg"
                textAlign="flex-start"
                textStyle={{ paddingLeft: "24px", fontWeight: 700 }}
                isHasAddonAfter={false}
                addonAfterText="更多"
                addonAfterTextStyle={{
                  fontSize: "14px",
                  color: "#ffffff",
                  textDecoration: "underline",
                }}
                style={{
                  marginBottom: "20px",
                  width: "1000px",
                  marginTop: "20px",
                }}
                isTextHasIcon={false}
                hoverStyle=""
                nodeId="node_ocl8u2cvve25"
              />
            </LayoutComponent>
            <LayoutComponent isCenter={true} nodeId="node_oclnsxs67u2">
              <NewsList_12
                newsChip={{
                  $data: true,
                  id: "288730",
                  type: "recommend",
                  title: "新闻内容",
                  default: { type: "recommend", id: "285873" },
                  uuid: "e4e5c7f4",
                  force: 1734544101713,
                }}
                colNum={3}
                thumbnailWidth={320}
                thumbnailHeight={180}
                showThumbnailHoverScale={true}
                isHasTitle={true}
                titleRows={2}
                titleHoverColor="#8b6028"
                titleStyle={{
                  color: "#2b2b2b",
                  fontSize: "18px",
                  lineHeight: "24px",
                  fontWeight: 700,
                  paddingLeft: "0px",
                  paddingRight: "0px",
                  textAlign: "justify",
                  marginLeft: "20px",
                  marginRight: "20px",
                  marginBottom: "10px",
                  paddingTop: "15px",
                  paddingBottom: "15px",
                  borderStyle: "none",
                }}
                showSummary={false}
                summaryRows={3}
                summaryStyle={{
                  color: "#666666",
                  fontSize: "14px",
                  lineHeight: "26px",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  textAlign: "justify",
                  paddingTop: "10px",
                  paddingBottom: "15px",
                }}
                moreText=""
                moreStyle={{ color: "#3086F3" }}
                itemStyle={{
                  borderColor: "#ebebeb",
                  borderWidth: "1px",
                  borderStyle: "solid",
                }}
                formatImageType={2}
                style={{ borderBottomStyle: "none", width: "1000px" }}
                hoverStyle=""
                titleHeight={50}
                nodeId="node_ocl8u8xf684"
              />
            </LayoutComponent>
          </Container>
          <LayoutComponent
            width={1000}
            isCenter={true}
            nodeId="node_ocl98alx19i"
            hoverStyle=""
          >
            <Title
              text=""
              height={40}
              image="https://x0.ifengimg.com/ucms/2024_51/5425C62E681418A4F8536C30CBA8AD391B6B9B27_size146_w2000_h140.jpg"
              textAlign="flex-start"
              textStyle={{ paddingLeft: "24px", fontWeight: 700 }}
              isHasAddonAfter={false}
              addonAfterText="更多"
              addonAfterTextStyle={{
                fontSize: "14px",
                color: "#ffffff",
                textDecoration: "underline",
              }}
              style={{
                marginTop: "30px",
                marginBottom: "5px",
                width: "1000px",
                height: "70px",
              }}
              isTextHasIcon={false}
              hoverStyle=""
              nodeId="node_ocl93sv4mm1"
            />
          </LayoutComponent>
        </Container>
        <LayoutComponent
          isCenter={true}
          nodeId="node_ocl988i9ym2"
          hoverStyle=""
        >
          <Swiper_5
            swiperChip={{
              $data: true,
              id: "288732",
              type: "recommend",
              title: "轮播图数据",
              default: { type: "recommend", id: "286116" },
              uuid: "709f977b",
              force: 1734442347478,
            }}
            swiperWidth={1000}
            height={562}
            formatImageType={0}
            isAutoPlay={true}
            autoSpeed={3000}
            isHasNav={true}
            leftNavImage="http://p2.ifengimg.com/l/2018/5/15a8462c875f75e/leftButton.png"
            rightNavImage="http://p1.ifengimg.com/l/2018/5/15a8462c875f75e/rightButton.png"
            navWidth={57}
            navHeight={64}
            navY={249}
            navX={1000}
            isHasTitle={true}
            titleLeft={0}
            titleRight={0}
            titleY={60}
            titleStyle={{
              color: "#ffffff",
              fontSize: "20px",
              lineHeight: "28px",
              backgroundColor: "rgba(0, 0, 0, 0.65)",
              paddingTop: "15px",
              paddingRight: "20px",
              paddingBottom: "15px",
              paddingLeft: "20px",
            }}
            hoverStyle=""
            style={{}}
            nodeId="node_ocl8u8dees97"
          />
        </LayoutComponent>
        <Container width={1000} isCenter={true} nodeId="node_oclnmz5bix1">
          <Title
            text=""
            height={40}
            image="https://x0.ifengimg.com/ucms/2024_51/CD140CEF858A09B1E301C1077B6469F50F7C06D0_size143_w2000_h140.jpg"
            textAlign="flex-start"
            textStyle={{ paddingLeft: "24px", fontWeight: 700 }}
            isHasAddonAfter={false}
            addonAfterText="更多"
            addonAfterTextStyle={{
              fontSize: "14px",
              color: "#ffffff",
              textDecoration: "underline",
            }}
            style={{ marginTop: "30px", width: "1000px", height: "70px" }}
            isTextHasIcon={false}
            hoverStyle=""
            nodeId="node_ocl9ksctaz2"
          />
        </Container>
        <Container width={1000} isCenter={true} nodeId="node_oclnmz5bix3">
          <ImageLink
            image=""
            url=""
            isBlock={false}
            width={285}
            objectFit=""
            nodeId="node_oclepbo85c9"
            hoverStyle=""
            style={{
              height: "auto",
              border: "1px solid rgba(34,34,34, .1)",
              marginBottom: "26px",
            }}
            height={300}
          />
          <ImageLink
            image="https://x0.ifengimg.com/ucms/2024_51/6DF543F2ABC3CE3198535F376B7B38A719764DCD_size30_w980_h275.png"
            url=""
            isBlock={false}
            width={246}
            objectFit="contain"
            nodeId="node_oclepbo85c9"
            hoverStyle=""
            style={{
              height: "114px",
              border: "1px solid rgba(34,34,34, .1)",
              width: "246px",
            }}
            height={114}
          />
        </Container>
        <Footer
          year="2022"
          style={{ marginTop: "50px" }}
          hoverStyle=""
          textColor="#212223"
          nodeId="node_ocl8u8dees9i"
        />
      <ChipEdit transform={chipDataTransform} />
</div>
    );
  }
}

export default Layout$$Page;

function __$$eval(expr) {
  try {
    return expr();
  } catch (error) {}
}

function __$$evalArray(expr) {
  const res = __$$eval(expr);
  return Array.isArray(res) ? res : [];
}

function __$$createChildContext(oldContext, ext) {
  const childContext = {
    ...oldContext,
    ...ext,
  };
  childContext.__proto__ = oldContext;
  return childContext;
}
